import axios from 'axios'
import { get } from 'svelte/store'
import { flatMap, filter, isEqual } from 'lodash'
import { server_path, previews_sort_order, previews_tracking, previews_font_size, text_entered, previews_leading, dark_theme, selected_text_case, detected_fonts, user, user_last_saved_selection_form_data, previews_are_google_fonts } from '../stores'
import { reloadFontsInSelections } from '../services/user'

export async function saveSelection(selected_selection, autosave = false) {
  // exit if not logged in
  if (!get(user)) return

  // exit if google fonts
  if (get(previews_are_google_fonts)) return

  // is existing selection selected?
  let selection_id = selected_selection ? selected_selection.id : undefined

  // get postscriptName array of currently selected fonts and turn into piped string
  let fonts_to_save
  fonts_to_save = flatMap(filter(get(detected_fonts), 'selected'), f => f.postscript_name).join('|-|')

  // guard
  if (fonts_to_save.length === 0) { console.error('no fonts selected to save'); return }

  let form_data = new FormData()
  if (selection_id) form_data.append('selection_id', selection_id)
  form_data.append('user_id', get(user).id)
  form_data.append('wordmark', get(text_entered))
  form_data.append('font_names', fonts_to_save)
  form_data.append('tracking', get(previews_tracking))
  form_data.append('line_space', get(previews_leading))
  form_data.append('font_scale', get(previews_font_size))
  form_data.append('dark_theme', get(dark_theme) ? 1 : 0)
  form_data.append('char_case', get(selected_text_case) ? get(selected_text_case) : null)
  form_data.append('sort_order', get(previews_sort_order))
  
  if (autosave) {
    form_data.append('autosave', 1)
    if (isEqual(formDataValuesAsString(form_data), get(user_last_saved_selection_form_data))) {
      console.log("User - not saving already autosaved selection history")
      return
    }
    storeFormDataValues(form_data)
  } else {
    form_data.append('autosave', 0)
  }

  let save_response = postSaveSelection(form_data, autosave)
  if (save_response.data === false){
    return false
  } else {
    reloadFontsInSelections()
    return true
  }
}

function storeFormDataValues(form_data) {
  user_last_saved_selection_form_data.set(formDataValuesAsString(form_data))
}

function formDataValuesAsString(form_data) {
  let values = ""
  for (const value of form_data.values()) {
    values += String(value);
  }
  return values
}

function postSaveSelection(form_data, autosave) {
  if (autosave) {
    storeFormDataValues(form_data)
    console.log('User - auto-saving selection')
  }
  else {
    console.log('User - auto-saved selection')
  }
  return axios.post(get(server_path) + 'selections/save.php', form_data, { withCredentials: true })
}